import { render, staticRenderFns } from "./KlaviyoForm.vue?vue&type=template&id=cdada158&scoped=true&"
import script from "./KlaviyoForm.vue?vue&type=script&lang=js&"
export * from "./KlaviyoForm.vue?vue&type=script&lang=js&"
import style0 from "./KlaviyoForm.vue?vue&type=style&index=0&id=cdada158&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdada158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdada158')) {
      api.createRecord('cdada158', component.options)
    } else {
      api.reload('cdada158', component.options)
    }
    module.hot.accept("./KlaviyoForm.vue?vue&type=template&id=cdada158&scoped=true&", function () {
      api.rerender('cdada158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/forms/KlaviyoForm.vue"
export default component.exports